import { render, staticRenderFns } from "./quickViewComponent.vue?vue&type=template&id=046874a1&scoped=true"
import script from "./quickViewComponent.vue?vue&type=script&lang=js"
export * from "./quickViewComponent.vue?vue&type=script&lang=js"
import style0 from "./quickViewComponent.vue?vue&type=style&index=0&id=046874a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046874a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046874a1')) {
      api.createRecord('046874a1', component.options)
    } else {
      api.reload('046874a1', component.options)
    }
    module.hot.accept("./quickViewComponent.vue?vue&type=template&id=046874a1&scoped=true", function () {
      api.rerender('046874a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/quickViewComponent.vue"
export default component.exports